import React, { Component } from "react";
import {
    Layout,
    DatePicker,
    Table,
    Divider,
    Modal,
    Form,
    Input,
    Pagination,
    Button,
    Select,
    message,
} from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import './paper.less'
import '../../assets/css/admin.less'
import {
    reqAddPaper, reqAssign, reqAssignClass,
    reqClassList, reqDeleteClassAssign, reqDeletePaper, reqPaper,
    reqPaperAssign,
    reqPaperList, reqPubPaper,
    reqTypeNum, reqCopy
} from "../../api";
import moment from 'moment'
import locale from 'antd/lib/date-picker/locale/zh_CN'
import 'moment/locale/zh-cn'

moment.locale('zh-cn');

const { Content } = Layout;
const { Option } = Select;
// const { RangePicker } = DatePicker;

/**
 * 综合考核路由组件
 */
export class Paper extends Component {

    state = {
        total: 0,
        page: 1,
        size: 10,
        paperList: [],
        selectValue: [],
        ModalText: '',
        visible: false,
        classList: [],
        name: '',
        QList: [],
        questionAuto: [{ answer: "", question: "" }],
        visibleR: 'none',
        cases: {},
        skill: {},
        totalScore: 0,
        visiblePub: false,
        startTime: '',
        endTime: '',
        examTime: 0,
        record: '',
        paper: {},
        qA: {},
        qB: {},
        qX: {},
        qCase: {},
        selectName: [],
        conflict: '',
        deleteVisible: false,
        copyVisible: false,
        deleteCase: '',
        deleteType: '',
        deleteIds: '',
        selectedRowKeys: [],
        fuzzyName: '',
        copyId: '',
        examination: ''
    };

    backControl = (index) => {
        let rows = document.getElementsByClassName("ant-table-row");
        for (let i = 0; i < rows.length; i++) {
            if (i === index) {
                document.getElementsByClassName("ant-table-row")[i].style.cssText = "background-color: #CCEBFF;";
            } else {
                if ((i + 1) % 2 === 0) {
                    document.getElementsByClassName("ant-table-row")[i].style.cssText = "background-color: #fff;";
                } else {
                    document.getElementsByClassName("ant-table-row")[i].style.cssText = "background-color: #f0f0f0;";
                }
            }
        }
    };

    getPaperList = async (data) => {
        const result = await reqPaperList(data);
        // console.log(result);
        if (result.code === '000000') {
            this.setState({
                paperList: result.data.rows,
                total: result.data.total,
                page: result.data.page
            });
            if (result.data.total > 0) {
                let pid = sessionStorage.getItem("pid");
                let paper = "";
                if (pid && pid !== "" && pid !== "0") {
                    this.getQList(pid);
                    const paperData = await reqPaper(pid);
                    paper = paperData.data;
                    let index = sessionStorage.getItem("pIndex") - 0;
                    this.backControl(index);
                } else {
                    this.getQList(result.data.rows[0].id);
                    this.backControl(0);
                    paper = result.data.rows[0];
                }
                this.setState({
                    paper: paper
                });
            }
        } else {
            message.error(result.msg);
        }
    };

    getQList = async (id) => {
        const result = await reqAssign(id, { page: 1, size: 10 });
        if (result.code === '000000') {
            this.setState({
                QList: result.data.rows
            })
        }
    };

    queList = async (record, index) => {
        sessionStorage.setItem("pIndex", index);
        this.backControl(index);
        this.setState({
            paper: record
        });
        sessionStorage.setItem("pid", record.id);
        this.getQList(record.id);
    };

    searchList = async () => {
        let data = {
            page: 1,
            size: 10
        };
        let name = document.getElementsByClassName("search_name")[0].value;
        if (name && name !== '') {
            data["name"] = name;
            this.setState({
                fuzzyName: name
            })
        } else {
            this.setState({
                fuzzyName: '',
            })
        }
        this.getPaperList(data);
    };

    pageClick = async (page) => {
        sessionStorage.clear();
        let name = document.getElementsByClassName("search_name")[0].value;
        let data = {
            page: page,
            size: 10
        };
        if (name !== '') {
            data["name"] = name;
        }
        this.getPaperList(data);
    };

    editPaper = async (record) => {
        sessionStorage.setItem("pid", record.id);
        sessionStorage.setItem("pStatus", "none");
        sessionStorage.setItem("pStatusN", "block");
        this.props.history.push("/previewCom");
    };

    //复制
    copyModal = async (record) => {
        this.setState({
            copyId: record.id,
            examination: record.name,
            copyVisible: true
        })

    };

    copyOnok = async () => {
        const result = await reqCopy(this.state.copyId);
        if (result.code === '000000') {
            this.getPaperList({ page: this.state.page, size: 10 });
            message.success("复制试卷成功");
        }
        this.setState({
            copyVisible: false
        })
    }

    showAddModal = () => {
        this.setState({
            visible: true,
            ModalText: '试卷内容填写',
            visibleR: 'block'
        });
    };

    showPubModal = async (record, index) => {
        this.setState({
            visiblePub: true,
            record: record
        });
        sessionStorage.setItem("pid", record.id);
        sessionStorage.setItem("pIndex", index)
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            visiblePub: false,
            conflict: "",
            deleteVisible: false,
            deleteCase: '',
            examination: '',
            deleteType: '',
            deleteIds: '',
            selectedRowKeys: [],
            copyVisible: false,
        });
    };

    getClassList = async (data) => {
        const result = await reqClassList(data);
        if (result.code === '000000') {
            this.setState({
                classList: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };

    addPaper = async (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values1) => {
            // console.log(err);
            if (!err) {
                // console.log(3);
                const result = await reqAddPaper(values1);
                if (result.code === '000000') {
                    sessionStorage.setItem("pid", result.data.id);
                    sessionStorage.setItem("totalScore", this.state.totalScore);
                    sessionStorage.setItem("pStatus", "inline-block");
                    sessionStorage.setItem("pStatusN", "none");
                    this.props.history.push('/previewCom')
                }
            }
        });
    };

    pubPaper = async (e) => {
        e.preventDefault();
        // this.state.startTime && this.state.endTime &&
        // console.log(this.state.selectName);
        if (this.state.startTime && this.state.endTime && this.state.selectName.length != 0) {
            let conflict = "";
            if (this.state.record.paperStatus === 'DRAFT') {
                await reqPubPaper(this.state.record.id)
            }
            for (let i = 0; i < this.state.selectValue.length; i++) {
                const result = await reqAssignClass(this.state.selectValue[i], {
                    begin: this.state.startTime,
                    end: this.state.endTime
                });
                if (result.data.total > 0) {
                    for (let j = 0; j < this.state.selectName.length; j++) {
                        if (this.state.selectValue[i] === this.state.selectName[j].split(',')[0])
                            conflict += (this.state.selectName[j].split(',')[1] + " ");
                    }
                }
            }
            if (conflict === "") {
                let record = this.state.record;
                let cid = '';
                let values = this.state.selectValue;
                for (let i = 0; i < values.length; i++) {
                    cid += values[i];
                    if (i < values.length - 1) {
                        cid += ','
                    }
                }
                let data = new FormData();
                data.append("begin", this.state.startTime);
                data.append("end", this.state.endTime);
                const result = await reqPaperAssign(record.id, cid, data);
                if (result.code === '000000') {
                    sessionStorage.setItem("pid", record.id);
                    this.getPaperList({ page: this.state.page, size: 10 });
                    message.success("发布成功");
                    this.handleCancel();
                }
            } else {
                this.setState({
                    conflict: conflict
                })
            }
        } else {
            message.error('请输入必填信息')
        }


    };

    selectValue = (value) => {
        let arr = [];
        for (let i = 0; i < value.length; i++) {
            arr.push(value[i].split(",")[0])
        }
        this.setState({
            selectValue: arr,
            selectName: value
        });
    };

    datePickerStart = async (value) => {
        // console.log("start", value ? value.valueOf() : 0)
        // console.log("start", value ? value.valueOf()-value.valueOf()%60000 : 0)
        // console.log(moment(value).valueOf(),);
        // let examTime = (moment(value[1]).valueOf() - moment(value[0]).valueOf()) / (60 * 1000);
        this.setState({
            startTime: value.valueOf(),
        });
    };

    datePickerEnd = async (value) => {
        // console.log("end", value ? value.valueOf() : 0)
        // console.log("end", value ? value.valueOf() : 0)
        // this.setState({
        //     endTime: moment(value).valueOf(),
        // });
        let examTime = ((value.valueOf() - value.valueOf() % 60000) - (this.state.startTime - this.state.startTime % 60000)) / (60 * 1000);
        this.setState({
            endTime: value.valueOf(),
            examTime: examTime
        });
        // console.log(examTime);
    };



    showDeleteModal = async (record, type) => {
        let deleteCase = "";
        let deleteIds = "";
        let deleteVisible = false;
        if (type === 'class') {
            if (new Date().getTime() > record.beginTime) {
                message.error("考试时间已过，不能删除");
                deleteVisible = false;
            } else {
                deleteCase = "将删除“" + record.classRoomName + "”的考试，同时删除本场考试的所有成绩";
                deleteIds = record.classRoomId;
                deleteVisible = true;
            }
        } else if (type === 'paper') {
            deleteCase = "确定删除吗？";
            deleteIds = record.id;
            deleteVisible = true;
        } else {
            if (this.state.deleteIds === '') {
                message.info("没有选中行");
                deleteVisible = false;
            } else {
                deleteCase = "确定删除吗？";
                deleteIds = this.state.deleteIds;
                deleteVisible = true;
            }
        }
        this.setState({
            deleteVisible: deleteVisible,
            deleteCase: deleteCase,
            deleteIds: deleteIds,
            deleteType: type
        });
    };

    deleteCases = async () => {
        let result = "";
        if (this.state.deleteType === 'class') {
            result = await reqDeleteClassAssign(this.state.paper.id, this.state.deleteIds)
            sessionStorage.setItem("pid", this.state.paper.id);
        } else {
            result = await reqDeletePaper(this.state.deleteIds);
            sessionStorage.setItem("pid", "");
        }
        if (result.code === '000000') {
            message.success("删除成功");
            this.handleCancel();
            this.getPaperList({ page: this.state.page, size: 10 });
        }
    };

    clearAll = () => {
        sessionStorage.clear();
        window.location.reload();
    };

    componentDidMount = async () => {
        this.getPaperList({
            page: 1,
            size: 10
        });
        this.getClassList({
            page: 1,
            size: 100,
            status: true
        });
        const result = await reqTypeNum();
        this.setState({
            skill: result.data.skill,
            cases: result.data.cases
        });
        document.getElementsByClassName("ant-menu-item")[6].click();
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total) => {
        return '共' + total + '条记录/每页' + this.state.size + '条';
    };

    calculate = () => {
        let numA = document.getElementById("questionACnt").value ? document.getElementById("questionACnt").value : 0;
        let perA = document.getElementById("scorePerA").value ? document.getElementById("scorePerA").value : 0;
        let num2B = document.getElementById("questionB2Cnt").value ? document.getElementById("questionB2Cnt").value : 0;
        let num3B = document.getElementById("questionB3Cnt").value ? document.getElementById("questionB3Cnt").value : 0;
        let perB = document.getElementById("scorePerB").value ? document.getElementById("scorePerB").value : 0;
        let numX = document.getElementById("questionXCnt").value ? document.getElementById("questionXCnt").value : 0;
        let perX = document.getElementById("scorePerX").value ? document.getElementById("scorePerX").value : 0;
        let countCase = document.getElementById("casesCnt").value ? document.getElementById("casesCnt").value : 0;
        let numCase = document.getElementById("casesQuestionCnt").value ? document.getElementById("casesQuestionCnt").value : 0;
        let perCase = document.getElementById("casesScorePer").value ? document.getElementById("casesScorePer").value : 0;
        let totalScore = numA * perA + (num2B * 2 + num3B * 3) * perB + numX * perX + countCase * numCase * perCase;
        this.setState({
            totalScore: totalScore
        })
    };

    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return state;
        };
    };

    render() {


        const { getFieldDecorator } = this.props.form;
        const { total, visiblePub, cases, skill, page, selectedRowKeys, examTime, paperList, ModalText, visible, classList, QList, totalScore, deleteVisible, copyVisible, deleteCase, examination } = this.state;

        const columns = [
            {
                title: '试卷名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '新建时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: (text, record) => (
                    <span>{moment(record.createTime).format("YYYY-MM-DD")}</span>
                ),
            },
            {
                title: '操作',
                key: 'action',
                width: 170,
                render: (text, record) => (
                    <span>
                        <a onClick={this.editPaper.bind(this, record)}>查看</a>
                        <Divider type="vertical" />
                        <a onClick={this.showDeleteModal.bind(this, record, 'paper')}>删除</a>
                        <Divider type="vertical" />
                        <a style={{ color: "#6F7176" }} onClick={this.copyModal.bind(this, record)}>复制</a>
                    </span>
                ),
            },
            {
                title: '发布',
                key: 'pub',
                width: 100,
                render: (text, record, index) => (
                    <span>
                        <a className='pub_button' onClick={this.showPubModal.bind(this, record, index)}>发布</a>
                    </span>
                ),
            }
        ];

        const columnQ = [
            {
                title: '考试班级',
                dataIndex: 'classRoomName',
                key: 'classRoomName',
            },
            {
                title: '考试时间',
                dataIndex: 'beginTime',
                key: 'beginTime',
                render: (text, record) => (
                    <span>{moment(record.beginTime).format("YYYY-MM-DD HH:mm:ss")}</span>
                ),
            },
            {
                title: '操作',
                key: 'action',
                render: (text, record) => (
                    <span>
                        <a style={{ color: "#e20101" }} onClick={this.showDeleteModal.bind(this, record, 'class')} >取消考试</a>
                    </span>
                ),
            }
        ];

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                let name = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    name.push(selectedRows[i].name)
                }
                this.setState({
                    deleteIds: selectedRowKeys.toString(),
                    deleteCase: name.toString(),
                    selectedRowKeys: selectedRowKeys,
                })
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className='table_right p_check'>
                            <div className='table_search'>
                                <Button className='batch_delete' onClick={this.showDeleteModal.bind(this, {}, 'batch')}>批量删除</Button>
                                <Button className='add_class' onClick={this.showAddModal}>新增</Button>
                                <Button className='batch_delete clear' onClick={this.clearAll}>重置</Button>
                                <Button className='batch_delete search' onClick={this.searchList.bind(this)}>检索</Button>
                                <div className='search_box' style={{ width: 260 }}>
                                    <label>试卷名称</label>
                                    <Input id='search_input' className="search_name" />
                                </div>
                            </div>
                            <Table rowSelection={rowSelection} columns={columns} pagination={false}
                                onRow={(record, index) => {
                                    return {
                                        onClick: this.queList.bind(this, record, index)
                                    }// 点击行
                                }} dataSource={paperList} rowKey={paperList => paperList.id} />
                            <Pagination total={total} current={page} onChange={this.pageClick} itemRender={this.itemRender} showTotal={this.showTotal} />
                        </div>
                        <div className='paper_right'>
                            <div className='right_title'><span>试卷发布情况</span></div>
                            <Table columns={columnQ}
                                // onRow={record => {
                                //     return {
                                //         onMouseEnter:this.examMore.bind(this, record)
                                //     }// 点击行
                                // }}
                                pagination={false} dataSource={QList} rowKey={QList => QList.id} />
                        </div>
                        <Modal className='paper_modal' title={ModalText} visible={visible} onCancel={this.handleCancel}
                            footer={null} destroyOnClose='true'>
                            <Form onSubmit={this.addPaper}>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue: this.state.paper.id,
                                    })(<Input hidden />)}
                                </Form.Item>
                                <Form.Item label="试卷名称">
                                    {getFieldDecorator('name', {
                                        rules: [{ required: true, message: '请输入试卷名称!' }],
                                    })(<Input placeholder={'请输入试卷名称'} autoComplete={"off"} />)}
                                </Form.Item>
                                <Form.Item>
                                    <label>综合考核</label><span className='tips'>(已知题库总量：A型题{skill.acnts}个，B型题{skill.bcnts}个，X型题{skill.xcnts}个)</span>
                                    <div style={{ display: "block" }}>
                                        <Form.Item label="A型题:">
                                            <span style={{ marginLeft: 20 }}>共</span>
                                            {getFieldDecorator('questionACnt', {
                                                rules: [{ required: true, message: '请输入A型题数目!' }],
                                            })(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>题</span>
                                        </Form.Item>
                                        <Form.Item style={{ marginLeft: 40 }}>
                                            <span>每题</span>
                                            {getFieldDecorator('scorePerA', {
                                                rules: [{ required: true, message: '请输入A型题分数!' }],
                                            })(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>分</span>
                                        </Form.Item>
                                    </div>
                                    <div style={{ display: "block" }}>
                                        <span className={"star"}>*</span>
                                        <label className="text_B">B型题</label>
                                        <span className="text_after">:</span>
                                        <Form.Item >
                                            <span style={{ marginLeft: 20 }}>共</span>
                                            {getFieldDecorator('questionB2Cnt')(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>大题</span>
                                            <span className='que_b1'>(含2小题)</span>
                                        </Form.Item>
                                        <Form.Item style={{ marginLeft: 27 }}>
                                            <span>每题</span>
                                            {getFieldDecorator('scorePerB')(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>分</span>
                                        </Form.Item>
                                        <Form.Item style={{ marginLeft: 61 }}>
                                            <span style={{ marginLeft: 20 }}>共</span>
                                            {getFieldDecorator('questionB3Cnt')(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>大题</span>
                                            <span className='que_b1'>(含3小题)</span>
                                        </Form.Item>
                                    </div>
                                    <div style={{ display: "block" }}>
                                        <Form.Item label="X型题:">
                                            <span style={{ marginLeft: 20 }}>共</span>
                                            {getFieldDecorator('questionXCnt', {
                                                rules: [{ required: true, message: '请输入X型题数目!' }],
                                            })(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>题</span>
                                        </Form.Item>
                                        <Form.Item style={{ marginLeft: 40 }}>
                                            <span>每题</span>
                                            {getFieldDecorator('scorePerX', {
                                                rules: [{ required: true, message: '请输入X型题分数!' }],
                                            })(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>分</span>
                                        </Form.Item>
                                    </div>
                                </Form.Item>
                                <Form.Item>
                                    <label>病例考核</label><span className='tips'>(已知病例总量{cases.cnt}个，病例题目可选1~{cases.maxQCnts}个)</span>
                                    <div>
                                        <Form.Item label="病例数量">
                                            {getFieldDecorator('casesCnt', {
                                                initialValue: 1,
                                                rules: [{ required: true, message: '请输入病例数量!' }],
                                            })(<Input disabled className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>个</span>
                                        </Form.Item>
                                        <Form.Item label="病例题目" style={{ marginLeft: 20 }}>
                                            <span>共</span>
                                            {getFieldDecorator('casesQuestionCnt', {
                                                rules: [{ required: true, message: '请输入病例题目!' }],
                                            })(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>题</span>
                                        </Form.Item>
                                        <Form.Item label="每题" className='per_ill'>
                                            {getFieldDecorator('casesScorePer', {
                                                rules: [{ required: true, message: '请输入病例题目!' }],
                                            })(<Input className='per_input' autoComplete={"off"} onChange={this.calculate.bind(this)} />)}
                                            <span>分</span>
                                        </Form.Item>
                                    </div>
                                </Form.Item>
                                <Form.Item className='score'>
                                    <span>试卷总分：{totalScore}</span>
                                </Form.Item>
                                <Form.Item className="paper_button">
                                    <Button type="primary" htmlType="submit">
                                        预览试卷
                                    </Button>
                                    <Button onClick={this.handleCancel} className="gray">
                                        取消
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal className='paper_modal' title={'发布信息填写'} visible={visiblePub}
                            onCancel={this.handleCancel}
                            footer={null} destroyOnClose='true'>
                            <Form onSubmit={this.pubPaper}>
                                <div style={{ fontSize: '16px' }}> <span style={{ color: "red" }}>*</span> 考试班级</div>
                                <Form.Item className='select'>
                                    <Select onChange={this.selectValue} mode="multiple">
                                        {
                                            classList && classList.map((item, index) => (
                                                <Option key={index} value={item.id + ',' + item.name}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>

                                </Form.Item>

                                <div style={{ fontSize: '16px' }}> <span style={{ color: "red" }}>*</span> 考试时间</div>

                                <Form.Item className='select'>
                                    <div style={{ display: "flex",marginTop:'10px' }}>
                                        <span>开始时间：&nbsp;</span>
                                        <div>
                                            <DatePicker
                                                // showTime={{ format: 'HH:mm:ss' }}
                                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                                format="YYYY-MM-DD HH:mm:ss"
                                                placeholder={"开始时间"}
                                                onChange={this.datePickerStart.bind(this)}
                                                locale={locale} style={{ minWidth: "287px" }} />
                                        </div>
                                    </div>

                                    {/* <RangePicker
                                        showTime={{ format: 'HH:mm:ss' }}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onOk={this.datePicker.bind(this)}
                                        locale={locale} /> */}


                                    <div style={{ marginTop: "20px" }}></div>
                                    <div style={{ display: "flex" }}>
                                        <div>结束时间：&nbsp;</div>
                                        <div>
                                            <DatePicker
                                                // showTime={{ format: 'HH:mm:ss' }}
                                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                                format="YYYY-MM-DD HH:mm:ss"
                                                placeholder={"结束时间"}
                                                onChange={this.datePickerEnd.bind(this)}
                                                locale={locale} style={{ minWidth: "287px" }} />
                                        </div>
                                    </div>
                                </Form.Item>


                                <Form.Item style={{ display: this.state.conflict === "" ? "none" : "block" }}>
                                    <div style={{ color: "red" }}>此时间段{this.state.conflict}已有考试安排</div>
                                </Form.Item>
                                <Form.Item className='score'>
                                    <span>考试时长：{examTime}分钟</span>
                                </Form.Item>
                                <Form.Item style={{ textAlign: "center" }} className='pub_btn'>
                                    <Button type="primary" htmlType="submit" style={{ marginRight: 50 }}>
                                        发布
                                    </Button>
                                    <Button onClick={this.handleCancel}>
                                        取消
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title="提示"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteCases}
                            onCancel={this.handleCancel}>
                            <div>{deleteCase}</div>
                        </Modal>
                        {/* copyVisible */}
                        <Modal
                            title="复制试卷"
                            visible={copyVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.copyOnok}
                            onCancel={this.handleCancel}>
                            <div style={{ fontSize: "16px" }}>确定生成与此试卷内容相同的新试卷吗？<br />(新试卷的名称将为“复制卷-{examination}”)</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapPaper = Form.create()(Paper);
export default WrapPaper;